//axios config
import axios from "axios";
import store from '@/state/store';
import {env} from "@/state/helpers";
import { toast, variants } from "@/helpers/toaster";

export default () => {

    axios.defaults.baseURL = env('VUE_APP_API_URL');
    axios.defaults.withCredentials = true;

    axios.interceptors.response.use(function (response) {
        return response;
    }, async function (error) {
        if (!error.response) toast("Greška u komunikaciji sa serverom.", variants.ERROR);
        
        const status = error.response.status;

        if (status === 401) {
            await axios.post(`/logout`);
            store.commit('auth/LOG_OUT');
            window.location = '/login'
        } else if (status === 404) {
            toast("Nepoznati resurs.", variants.ERROR);
        } else if (error.response.data && error.response.data.errors) {
            store.commit('errorBag/RECORD', error.response.data.errors);
        } else if (error.response.data && error.response.data.message && (status === 503 || (status < 500 && status >= 400))) {
            toast(error.response.data.message, variants.ERROR)    
        } else {
            // eslint-disable-next-line no-console
            toast("Greška u komunikaciji sa serverom.", variants.ERROR);
        }
        return Promise.reject(error);
    });
    // TODO: ADD loader to each request
    // axios.interceptors.response.use(function (response) {
    //     store.commit('loader/END_LOADING');

    //     return response;
    // });

    // axios.interceptors.request.use(function (request) {
    //     store.commit('loader/START_LOADING');

    //     return request;
    // });
};
